export const FolderPage = {
  FolderList: 1,
  CreateFolder: 2,
  AddContactToFolder: 3,
  InnerFolder: 4
}
